import DashboardLayout from "../../layouts/Dashboard";
import FormAttributeCRUDTable from "../../components/CRUD/Tables/FormAttributeCRUDTable";
import {useHistory} from "react-router-dom";
import useReload from "../../hooks/useReload";
import {FORM_ATTRIBUTE_DETAIL_ROUTE} from "../../routes";
import {formAttributeCRUD} from "../../http";

const FormAttributeList = ()=>{
    const history = useHistory()
    const {reload, reloadValue} = useReload();

    const detailAction =(id)=>{
        history.push(FORM_ATTRIBUTE_DETAIL_ROUTE(id),{
            review:true
        })
    }

    const editAction =(id)=>{
        history.push(FORM_ATTRIBUTE_DETAIL_ROUTE(id),{
            review:false
        })
    }

    const deleteAction =async(id)=> {
        try {
            await formAttributeCRUD.delete(id)
            reload()
        } catch (err) {

        }
    }
    return <DashboardLayout>
        <FormAttributeCRUDTable onClickDetailsButton={detailAction}
                             onClickDeleteButton={deleteAction}
                             onClickEditButton={editAction} reloadValue={reloadValue} />
    </DashboardLayout>
}

export default FormAttributeList 


